import { render, staticRenderFns } from "./ConfigurationDashboard.vue?vue&type=template&id=1df8a0ee&"
import script from "./ConfigurationDashboard.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports